import React from "react";
import Routes from "./routes/AppRoutes";

const App = () => <Routes />;
export default App;
